<script setup lang="ts">
import TextTooltip from './TextTooltip.vue'

defineProps<{
  show: boolean
  text: string
  x: number
  y: number
  width?: string
  maxHeight?: string
  zIndex?: number
}>()

const emit = defineEmits<{
  (e: 'mouseenter'): void
  (e: 'mouseleave'): void
}>()
</script>

<template>
  <TextTooltip
    :show="show"
    :text="text"
    :x="x"
    :y="y"
    :width="width"
    :maxHeight="maxHeight"
    :zIndex="zIndex"
    @mouseenter="emit('mouseenter')"
    @mouseleave="emit('mouseleave')"
  />
</template>
